export default __webpack_public_path__ + "static/media/cardcont1.e2ce93d9.png";